<!--
创建作业及创建测试完成
-->
<template>
  <div class="CatWebPcIndex">
    <div>
      <div class="header-step">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'studentTest' }">{{$t('jobManagementV2.studentTest')}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{$t('jobManagementV2.newTest')}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 卡片 -->
      <div class="file-card">
        <!-- 文件列表 -->
        <el-table :data="fileList"
          v-if="this.fileList.length"
          :header-cell-style="{
          background: '#F3F7FE',
          'padding': '0',
          'height':'47px',
        }"
          :cell-style="{background:'#fcfdfe'}"
          style="width: 950px"
          height="202"
          :default-sort="{ prop: 'date', order: 'descending' }"
          border>
          <el-table-column :label="$t('projectV2.index')"
            width="60"
            align="center"
            type="index">
          </el-table-column>
          <el-table-column :label="$t('jobManagementV2.fileName')"
            align="center"
            prop="name"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="$t('jobManagementV2.fileSize')"
            align="center"
            prop="size">
            <template slot-scope="scoped">
              <span v-if="scoped.row.size / 1024 < 1024">{{ (scoped.row.size / 1024).toFixed(2) }}KB</span>
              <span v-else>{{ (scoped.row.size / 1024 / 1024).toFixed(2) }}M</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('jobManagementV2.progress')"
            align="center"
            prop="percentage">
            <template slot-scope="scoped">
              <el-progress :stroke-width="8"
                :percentage="
                isNaN(scoped.row.percentage) ? 100 : scoped.row.percentage
              "></el-progress>
            </template>
          </el-table-column>
          <el-table-column :label="$t('projectV2.state')"
            align="center">
            <template slot-scope="scoped">
              <span class="success"
                v-show="scoped.row.isLoading === 1">{{
              $t("jobManagementV2.completed")
            }}</span>
              <span class="error"
                v-show="scoped.row.isLoading === 0">{{
              $t("jobManagementV2.failure")
            }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('projectV2.operation')"
            align="center">
            <template slot-scope="scoped">
              <div class="delete-btn "
                @click="delItem(scoped.row)">
                <p></p>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-upload class="upload-demo"
          v-show="!this.fileList.length"
          drag
          ref="upload"
          action
          :limit="1"
          :show-file-list="false"
          :file-list="fileList"
          :accept="$supportFileSuffixes().acceptStr"
          multiple
          :on-exceed="handleExceed"
          :http-request="uploadSectionFile"
          :on-change="uploadChange"
          :before-upload="beforeUploadFile">
          <div class="upload-img">
            <img src="./assets/images/uploadbkg.png"
              alt="" />
          </div>
          <div class="el-upload__text">
            <p v-html="$t('jobManagementV2.jobClickUpload')"></p>
            <p>{{ $t("jobManagementV2.supportedFormats") }}：<em>{{$supportFileSuffixes().tip}}</em></p>
          </div>
        </el-upload>
        <div class="upload"
          v-show="this.fileList.length">
          <el-upload class="upload-demo"
            drag
            ref="upload"
            action
            :show-file-list="false"
            :file-list="fileList"
            :accept="$supportFileSuffixes().acceptStr"
            multiple
            :on-exceed="handleExceed"
            :limit="1"
            :http-request="uploadSectionFile"
            :on-change="uploadChange"
            :before-upload="beforeUploadFile">
            <div class="el-upload__text">
              <p v-html="$t('jobManagementV2.jobClickUpload')"></p>
              <p>{{ $t("jobManagementV2.supportedFormats") }}：<em>{{$supportFileSuffixes().tip}}</em></p>
            </div>
          </el-upload>
        </div>
        <!-- 中文版 -->
        <el-form class="zhForm"
          :rules="rules"
          :model="ruleForm"
          ref="ruleForm"
          label-position="top"
          :hide-required-asterisk="true">
          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('jobManagementV2.testName')"
                class="name"
                prop="name">
                <el-input v-model.trim="ruleForm.name"
                  class="job-name-input"
                  :placeholder="$t('jobManagementV2.testInputText')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <div style="width:1px;height:1px;"></div>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('projectV2.langDesc')"
                class="langdesc">
                <el-col :span="11">
                  <el-form-item prop="sourceLang">
                    <el-select v-model="ruleForm.sourceLang"
                      @change="changeLanguageSourceLang()"
                      :placeholder="$t('jobManagementV2.selectText')">
                      <el-option v-for="(item, index) in sourceLangNameOpt"
                        :key="index"
                        :label="$i18n.locale === 'zh' ?item.sourceLangName : $langCase[item.sourceLang]"
                        :value="item.sourceLang">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <!-- <i class="icon-right"></i> -->
                  <div style="width:1px;height:1px;"></div>
                </el-col>
                <el-col :span="11">
                  <el-form-item prop="targetLang">
                    <el-select v-model="ruleForm.targetLang"
                      @change="changeLanguageTargetLang()"
                      :no-data-text="$t('jobManagementV2.targetLangNoData')"
                      :placeholder="$t('jobManagementV2.selectText')">
                      <el-option v-for="(item, index) in targetLangNameOpt"
                        :key="index"
                        :label="$i18n.locale === 'zh' ?item.targetLangName : $langCase[item.targetLang]"
                        :value="item.targetLang">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('projectV2.domain')"
                class="domain"
                prop="domainCode">
                <el-select v-model="ruleForm.domainCode"
                  :no-data-text="$t('jobManagementV2.targetLangNoData')"
                  :placeholder="$t('jobManagementV2.selectText')">
                  <el-option v-for="(item, index) in domainList"
                    :key="index"
                    :label=" $i18n.locale === 'zh' ? item.transDomainName : $domainCase[item.transDomainCode]"
                    :value="item.transDomainCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <div style="width:1px;height:1px;"></div>
            </el-col>

            <el-col :span="10">
              <el-form-item :label="$t('jobManagementV2.startTime')"
                class="createTime"
                prop="startTime">
                <el-date-picker v-model="ruleForm.startTime"
                  :picker-options="pickerOptions"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  :placeholder="$t('jobManagementV2.selectText')">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 截止时间 -->
          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('projectV2.limitTime')"
                class="deliverytime"
                prop="deliveryTime">
                <el-date-picker v-model="ruleForm.deliveryTime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="pickerOptions"
                  type="datetime"
                  :placeholder="$t('jobManagementV2.selectText')">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <div style="width:1px;height:1px;"></div>
            </el-col>

            <el-col :span="10">
              <el-form-item :label="$t('jobManagementV2.testType')"
                prop="projectProcessType">
                <el-select v-model="ruleForm.projectProcessType"
                  :placeholder="$t('newProjectV2.workFlowTip')">
                  <el-option v-for="(item, index) in projectFlow"
                    :key="index"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('jobManagementV2.machineTranslation')"
                prop="isPreMt">
                <el-switch v-model="ruleForm.isPreMt"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 英文版 -->
        <el-form v-if="false"
          class="enForm"
          :rules="rules"
          :model="ruleForm"
          ref="ruleForm"
          :label-position="$i18n.locale === 'zh'?'left':'right'"
          :hide-required-asterisk="true"
          label-width="180px">
          <el-row>
            <el-col :span="11">
              <el-form-item :label="$t('jobManagementV2.testName')"
                class="name"
                prop="name"
                label-width="107px">
                <el-input v-model.trim="ruleForm.name"
                  class="job-name-input"
                  :placeholder="$t('jobManagementV2.testInputText')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <div style="width:1px;height:1px;"></div>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('projectV2.langDesc')"
                class="langdesc">
                <el-col :span="11">
                  <el-form-item prop="sourceLang">
                    <el-select v-model="ruleForm.sourceLang"
                      @change="changeLanguageSourceLang()"
                      :placeholder="$t('jobManagementV2.selectText')">
                      <el-option v-for="(item, index) in sourceLangNameOpt"
                        :key="index"
                        :label="$langCase[item.sourceLang]"
                        :value="item.sourceLang">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <!-- <i class="icon-right"></i> -->
                  <div style="width:1px;height:1px;"></div>
                </el-col>
                <el-col :span="11">
                  <el-form-item prop="targetLang">
                    <el-select v-model="ruleForm.targetLang"
                      @change="changeLanguageTargetLang()"
                      :no-data-text="$t('jobManagementV2.targetLangNoData')"
                      :placeholder="$t('jobManagementV2.selectText')">
                      <el-option v-for="(item, index) in targetLangNameOpt"
                        :key="index"
                        :label="$langCase[item.targetLang]"
                        :value="item.targetLang">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item :label="$t('projectV2.domain')"
                class="domain"
                prop="domainCode"
                label-width="107px">
                <el-select v-model="ruleForm.domainCode"
                  :no-data-text="$t('jobManagementV2.targetLangNoData')"
                  :placeholder="$t('jobManagementV2.selectText')">
                  <el-option v-for="(item, index) in domainList"
                    :key="index"
                    :label="$domainCase[item.transDomainCode]"
                    :value="item.transDomainCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="1">
              <div style="width:1px;height:1px;"></div>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="$t('jobManagementV2.startTime')"
                class="createTime"
                prop="startTime">
                <el-col :span="11">
                  <el-form-item prop="starYearTodate">
                    <el-date-picker type="date"
                      :placeholder="$t('newProjectV2.dateTip')"
                      v-model="ruleForm.starYearTodate"
                      :editable="false"
                      :clearable="false"
                      @change="starTimeChange"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions"
                      style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="2"
                  class="line">-</el-col>
                <el-col :span="11">
                  <el-form-item prop="starHourMinuteSecond">
                    <el-time-select v-model="ruleForm.starHourMinuteSecond"
                      :picker-options="{
                  start: start,
                  step: '00:30',
                  end: '23:30',
                  
                }"
                      value-format="HH:mm:ss"
                      :editable="false"
                      :clearable="false"
                      :placeholder="$t('newProjectV2.timeTip')"
                      style="width: 100%"
                      @change="StarMinutsChange">
                    </el-time-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 截止时间 -->
          <el-row>
            <el-col :span="11">
              <el-form-item :label="$t('projectV2.limitTime')"
                class="deliverytime"
                label-width="107px">
                <el-row>
                  <el-col :span="11">
                    <el-form-item prop="yearTodate">
                      <el-date-picker type="date"
                        :placeholder="$t('newProjectV2.dateTip')"
                        v-model="ruleForm.yearTodate"
                        :editable="false"
                        :clearable="false"
                        @change="deliveryTimeChange"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        style="width: 100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2"
                    class="line">-</el-col>
                  <el-col :span="11">
                    <el-form-item prop="hourMinuteSecond">

                      <el-time-select @change="hourMinuteSecondChange"
                        v-model="ruleForm.hourMinuteSecond"
                        :picker-options="{
                  start: minuteSecond,
                  step: '00:30',
                  end: '23:30',
                  
                }"
                        value-format="HH:mm:ss"
                        :editable="false"
                        :clearable="false"
                        :placeholder="$t('newProjectV2.timeTip')"
                        style="width: 100%">
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-box">
          <button class="cancel"
            @click.prevent="cancel()">
            {{ $t("projectV2.cancel") }}
          </button>
          <button v-preventReClick
            class="setup"
            @click.prevent="createJobSub('ruleForm')">
            {{ $t("projectV2.created") }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { getUploadSign } from "../../services/newProjectApi";
import {
  createStudentJob,
  language,
  queryLanguageList,
  queryTransDomain,
} from "../../services/createJob";

export default {
  name: "CatWebPcIndex",

  data() {
    var checkDeliveryTime = (rule, value, callback) => {
      if (this.ruleForm.deliveryTime == "") {
        return callback(new Error(this.$t("projectV2.limitTimeNullText")));
      } else if (new Date(this.ruleForm.startTime) >= new Date(this.ruleForm.deliveryTime)) {
        return callback(new Error(this.$t("projectV2.limitTimeErrorTextV3")));
      } else if (new Date(this.ruleForm.deliveryTime) <= new Date()) {
        return callback(new Error(this.$t("projectV2.limitTimeErrorText")));
      } else {
        callback();
      }
    };
    var endDeliveryTime = (rule, value, callback) => {
      if (this.ruleForm.yearTodate == '') {
        return callback(new Error(this.$t("projectV2.limitTimeNullText")));
      } else if (new Date(this.ruleForm.deliveryTime) <= new Date()) {
        return callback(new Error(this.$t("projectV2.limitTimeErrorText")));
      }
      else if (new Date(this.ruleForm.yearTodate) < new Date(this.ruleForm.starYearTodate)) {
        return callback(new Error(this.$t("projectV2.limitTimeErrorTextV3")));
      } else if (new Date(this.ruleForm.startTime) >= new Date(this.ruleForm.deliveryTime)) {
        return callback(new Error(this.$t("projectV2.limitTimeErrorTextV3")));
      } else {
        callback();
      }
    };
    var checkStartTime = (rule, value, callback) => {
      if (this.ruleForm.startTime == '') {
        return callback(new Error(this.$t("projectV2.startTimeNullText")));
      } else if (new Date(this.ruleForm.startTime) >= new Date(this.ruleForm.deliveryTime)) {
        return callback(new Error(this.$t("projectV2.startTimeErrorText")));
      } else if (new Date(this.ruleForm.startTime) <= new Date()) {
        return callback(new Error(this.$t("projectV2.startTimeBeforeNow")));
      } else {
        callback();
      }
    };
    var checkStartDate = (rule, value, callback) => {
      if (this.ruleForm.starYearTodate == '') {
        return callback(new Error(this.$t("projectV2.startTimeNullText")));
      } else if (new Date(this.ruleForm.startTime).getTime() <= new Date().getTime()) {
        return callback(new Error(this.$t("projectV2.startTimeBeforeNow")));
      } else if (this.ruleForm.deliveryTime == ' :00') {

        callback();
      } else if (new Date(this.ruleForm.starYearTodate) > new Date(this.ruleForm.yearTodate)) {
        return callback(new Error(this.$t("projectV2.startTimeErrorText")));
      }
      else if (new Date(this.ruleForm.startTime) >= new Date(this.ruleForm.deliveryTime)) {
        return callback(new Error(this.$t("projectV2.startTimeErrorText")));
      } else {

        callback();
      }
    };
    var checkName = (rule, value, callback) => {
      if (
        this.ruleForm.name == null ||
        this.ruleForm.name.split(" ").join("").length == 0
      ) {
        return callback(new Error(this.$t("projectV2.testNameErrorText")));
      } else if (value.length < 2) {
        return callback(new Error(this.$t("jobManagementV2.testNameLengthValue1")));
      } else if (value.length > 30) {
        return callback(new Error(this.$t("jobManagementV2.testNameLengthValue2")));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000;
        },
      },
      ruleForm: {
        name: "",
        sourceLang: "",
        targetLang: "",
        domainCode: "",
        deliveryTime: "",
        startTime: "",
        yearTodate: "",
        hourMinuteSecond: '',
        starYearTodate: "",
        starHourMinuteSecond: "",
        projectProcessType: '1',
        isPreMt: false,
      },
      projectFlow: [{
        value: "1",
        label: this.$t('newProjectV2.translation')
      }],
      selDate: "",
      starDate: "",
      fileList: [],
      filePathList: [],
      reqDto: {},
      mtLangReqVo: {},
      host: "",
      formData: new FormData(),
      sourceLangNameOpt: [], //源语言
      targetLangNameOpt: [], //目标语言
      domainList: [], //领域
      transModel: 0,
      rules: {
        name: [{ validator: checkName, trigger: "change", required: true }],
        sourceLang: [
          {
            required: true,
            message: this.$t("jobManagementV2.targetLangNoData"),
            trigger: "change",
          },
        ],
        targetLang: [
          {
            required: true,
            message: this.$t("jobManagementV2.sourceLangNoData"),
            trigger: "change",
          },
        ],
        domainCode: [
          {
            required: true,
            message: this.$t("jobManagementV2.domainNoData"),
            trigger: "change",
          },
        ],
        deliveryTime: [
          { validator: checkDeliveryTime, trigger: "change", required: true },
        ],
        startTime: [
          { validator: checkStartTime, trigger: "change", required: true },
        ],
      },
    };
  },
  components: {},
  created() {
    this.querySourceLangName();
  },
  methods: {
    StarMinutsChange() {
      this.ruleForm.startTime = this.ruleForm.starYearTodate + ' ' + this.ruleForm.starHourMinuteSecond + ':00';
      this.ruleForm.deliveryTime = this.ruleForm.yearTodate + ' ' + this.ruleForm.hourMinuteSecond + ':00';
    },
    hourMinuteSecondChange() {
      this.ruleForm.startTime = this.ruleForm.starYearTodate + ' ' + this.ruleForm.starHourMinuteSecond + ':00';
      this.ruleForm.deliveryTime = this.ruleForm.yearTodate + ' ' + this.ruleForm.hourMinuteSecond + ':00';
    },
    //开始时间
    starTimeChange(val) {
      this.ruleForm.startTime = this.ruleForm.starYearTodate + ' ' + this.ruleForm.starHourMinuteSecond + ':00';
      this.ruleForm.deliveryTime = this.ruleForm.yearTodate + ' ' + this.ruleForm.hourMinuteSecond + ':00';
      this.starDate = val;
      let time = "00:00";
      let date = new Date();
      let day = '0' + date.getDate();
      let month = '0' + (date.getMonth() + 1);
      if (day.length === 3) {
        day = day.substring(1);
      }
      if (month.length === 3) {
        month = month.substring(1);
      }
      let today = date.getFullYear() + '-' + month + '-' + day;
      if (this.starDate === today) {
        if (date.getMinutes() === 0) {
          time = date.getHours() + ':00';
        } else if (date.getMinutes() <= 30) {
          time = date.getHours() + ':30';
        } else {
          time = (date.getHours() + 1) + ':00';
        }
      }
    },
    //截止时间
    deliveryTimeChange(val) {
      this.ruleForm.startTime = this.ruleForm.starYearTodate + ' ' + this.ruleForm.starHourMinuteSecond + ':00';
      this.ruleForm.deliveryTime = this.ruleForm.yearTodate + ' ' + this.ruleForm.hourMinuteSecond + ':00';
      this.selDate = val;
      let time = "00:00";
      let date = new Date();
      let day = '0' + date.getDate();
      let month = '0' + (date.getMonth() + 1);
      if (day.length === 3) {
        day = day.substring(1);
      }
      if (month.length === 3) {
        month = month.substring(1);
      }
      let today = date.getFullYear() + '-' + month + '-' + day;
      if (this.selDate === today) {
        if (date.getMinutes() === 0) {
          time = date.getHours() + ':00';
        } else if (date.getMinutes() <= 30) {
          time = date.getHours() + ':30';
        } else {
          time = (date.getHours() + 1) + ':00';
        }
      }
    },
    //自动检测语言
    queryLanguage(path) {
      let params = {
        path: path,
      };
      language(params)
        .then((res) => {
          this.ruleForm.sourceLang = res.result.sourceLang;
        })
        .then(() => {
          this.changeLanguageSourceLang();
        });
    },
    // 自定义文件上传开始
    uploadSectionFile(param) {
      let self = this;
      // 获得上传签名
      getUploadSign()
        .then(({ result }) => {
          // 上传地址
          this.host = result.host;

          let re = /([^\.\/\\]+)\.([a-z]+)$/i;
          let resultArr = re.exec(param.file.name);
          // 文件类型
          let type = resultArr[2].toLocaleLowerCase();
          let para = {
            ...result,
            key: `${result.keyPrefix}.${type}`,
            file: param.file,
          };
          Reflect.deleteProperty(para, 'keyPrefix');
          Reflect.deleteProperty(para, 'host');

          self.formData = new FormData();
          Object.keys(para).forEach(function (key) {
            self.formData.append(key, para[key]);
          });
          this.querySourceLangName();
          this.getFileHost(param);
        })
        .catch(() => {
          this.fileList.forEach((item) => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              item.isLoading = 0;
            }
          });
          this.$message({
            message: this.$t("jobManagementV2.uploadFileError"),
            type: "warning",
          });
        });
    },
    getFileHost(param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: (progressEvent) => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        },
      };
      axios
        .post(FileController, self.formData, config)
        .then((resp) => {
          let { result } = resp.data;
          this.fileList.forEach((item) => {
            if (item.uid === param.file.uid) {
              item.path = result.fileName;
              item.isLoading = 1;
              this.queryLanguage(result.fileName);
            }
          });
        })
        .catch(() => {
          this.fileList.forEach((item) => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              item.isLoading = 0;
            }
          });
        });
    },
    uploadChange(file) {
      this.fileList.push({
        ...file,
        path: "",
        isLoading: null,
      });
    },
    beforeUploadFile(file) {
      let re = /([^\.\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();
      // 文件是否超过大小
      let isLt20M = file.size / 1024 / 1024 > 20;

      let typeFlag = this.$supportFileSuffixes(type).isSupport;

      if (!typeFlag) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.onlySupportFormate', [this.$supportFileSuffixes().tip]));
        // 去除最后一个文件
        this.fileList.pop();
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: this.$t("jobManagementV2.uploadError"),
          type: "warning",
        });
        this.fileList.pop();
        return false;
      }

      this.fileList.slice(0, -1).forEach((item) => {
        if (item.name == file.name) {
          this.$message.closeAll();
          this.$message({
            message: this.$t("jobManagementV2.uploadErrorV2"),
            type: "warning",
          });
          this.fileList.pop();
          file.obp = true;
          return false;
        }
      });

      if (isLt20M) {
        this.$message.closeAll();
        this.$message({
          message: this.$t("jobManagementV2.uploadErrorV3"),
          type: "warning",
        });
        file.obp = true;
        return false;
      }
      return true;
    },
    handleExceed() {
      this.$message.closeAll();
      this.$message({
        message: this.$t("jobManagementV2.uploadErrorV4"),
        type: "warning",
      });
    },
    // 自定义文件上传结束
    delItem(row) {
      this.fileList.forEach((item, index) => {
        if (item.uid === row.uid) {
          this.fileList.splice(index, 1);
        }
      });
    },
    // 查询语言对
    // 查询对应目标语言
    changeLanguageSourceLang() {
      this.mtLangReqVo.sourceLang = this.ruleForm.sourceLang;
      this.mtLangReqVo.type = 2;
      this.queryTargetLangName(this.mtLangReqVo);
    },
    changeLanguageTargetLang() {
      this.queryDomain();
    },
    // 查询所有语言
    querySourceLangName() {
      queryLanguageList({ type: 1 }).then(({ result }) => {
        this.sourceLangNameOpt = result;
      });
    },
    queryTargetLangName(params) {
      queryLanguageList(params).then(({ result }) => {
        this.targetLangNameOpt = result.filter((item) => {
          return item.status === 1;
        });
        let tarItem = null
        this.targetLangNameOpt.forEach((item, index) => {
          if (item.targetLang == 'zh') {
            tarItem = item
            this.targetLangNameOpt.splice(index, 1)
          }
        })
        tarItem && this.targetLangNameOpt.unshift(tarItem)
        this.ruleForm.targetLang = this.targetLangNameOpt[0].targetLang;
        this.queryDomain();
      });
    },
    // 获取语言对下相关领域
    queryDomain() {
      let params = {
        sourceLangCode: this.ruleForm.sourceLang,
        targetLangCode: this.ruleForm.targetLang,
      };
      queryTransDomain(params).then(({ result }) => {
        this.domainList = result;
      });
    },
    createJobSub(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let starDate = this.ruleForm.starYearTodate + ' ' + this.ruleForm.starHourMinuteSecond + ':00';
          let date = this.ruleForm.yearTodate + ' ' + this.ruleForm.hourMinuteSecond + ':00';

          // 上传文件列表
          let arr = [];
          this.fileList.forEach((item) => {
            arr.push({
              name: item.name,
              filePath: item.path,
              fileSuffix: /([^\.\/\\]+)\.([a-z]+)$/i.exec(item.name)[2],
              transModel: this.transModel,
            });
          });
          let params = {
            transFileList: arr,
            targetLang: this.ruleForm.targetLang,
            sourceLang: this.ruleForm.sourceLang,
            domainCode: this.ruleForm.domainCode,
            name: this.ruleForm.name,
            deliveryTime: this.ruleForm.deliveryTime,
            startTime: this.ruleForm.startTime,
            projectProcessType: Number(this.ruleForm.projectProcessType),
            isPreMt: this.ruleForm.isPreMt ? 1 : 0,
            sourceType: 2,
            transModel: 1,
            memorySimilarPercent: 70,
            isAutoCommit: 0,
            isOpenQa: 1,
            isUseMemory: 1,
            ifRepeatLock: 0,
          };
          // 获取源语言中文名
          let sourceName = this.sourceLangNameOpt.find((i) => {
            return params.sourceLang === i.sourceLang;
          }).sourceLangName;

          // 获取目标语言中文名
          let targetName = this.targetLangNameOpt.find((i) => {
            return params.targetLang === i.targetLang;
          }).targetLangName;
          let langDesc = sourceName + ">" + targetName;
          params.langDesc = langDesc;
          createStudentJob(params)
            .then(({ success }) => {
              if (success) {
                this.$message.closeAll()
                this.$message.success(this.$t("jobManagementV2.creatingSuccessful"));
                this.$router.push({
                  name: "studentTest",
                });
              } else {
                this.$message.closeAll()
                this.$message.warning(this.$t('termBankV2.pleaseUploadFile'));
                return false;
              }
            })
            .catch(() => {
              this.$message.closeAll()
              this.$message.warning(this.$t("jobManagementV2.createError"));
              return false;
            });
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$router.push({ name: "studentTest" });
    },
  },
  computed: {
    start() {
      let time = "00:00";
      let date = new Date();
      let day = '0' + date.getDate();
      let month = '0' + (date.getMonth() + 1);
      if (day.length === 3) {
        day = day.substring(1);
      }
      if (month.length === 3) {
        month = month.substring(1);
      }
      let today = date.getFullYear() + '-' + month + '-' + day;
      if (this.starDate === today) {
        if (date.getMinutes() === 0) {
          time = date.getHours() + ':00';
        } else if (date.getMinutes() <= 30) {
          time = date.getHours() + ':30';
        } else {
          time = (date.getHours() + 1) + ':00';
        }
      }
      return time;
    },
    minuteSecond() {
      let time = "00:00";
      let date = new Date();
      let day = '0' + date.getDate();
      let month = '0' + (date.getMonth() + 1);
      if (day.length === 3) {
        day = day.substring(1);
      }
      if (month.length === 3) {
        month = month.substring(1);
      }
      let today = date.getFullYear() + '-' + month + '-' + day;
      if (this.selDate === today) {
        if (date.getMinutes() === 0) {
          time = date.getHours() + ':00';
        } else if (date.getMinutes() <= 30) {
          time = date.getHours() + ':30';
        } else {
          time = (date.getHours() + 1) + ':00';
        }
      }
      return time;
    }
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>
